import { lazy, LazyExoticComponent } from "react";

export type RouteChild = {
  path: string;
  key: string;
  component: LazyExoticComponent<() => JSX.Element>;
  isPrivate: boolean;
  exact: boolean;
};

const routeConfig: Array<RouteChild> = [
  {
    path: "/",
    key: 'home',
    component: lazy(() => import("../pages/home")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/expired",
    key: 'expired',
    component: lazy(() => import("../pages/activity")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/unusual",
    key: 'expired',
    component: lazy(() => import("../pages/activity")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/dataReceiveNumber",
    key: 'expired',
    component: lazy(() => import("../pages/dataReceiveNumber")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/dataLatestSend",
    key: 'expired',
    component: lazy(() => import("../pages/dataLatestSend")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/dataMasterAppStartNumber",
    key: 'expired',
    component: lazy(() => import("../pages/dataMasterAppStartNumber")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/dataLatestMasterAppStart",
    key: 'expired',
    component: lazy(() => import("../pages/dataLatestMasterAppStart")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/workCertificate",
    key: 'expired',
    component: lazy(() => import("../pages/workCertificate")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/loadingData",
    key: 'expired',
    component: lazy(() => import("../pages/loadingData")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/noData",
    key: 'expired',
    component: lazy(() => import("../pages/noData")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/diversion",
    key: 'expired',
    component: lazy(() => import("../pages/diversion")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/activityExpired",
    key: 'expired',
    component: lazy(() => import("../pages/expired")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/tools",
    key: 'index',
    component: lazy(() => import("../pages/activity")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/login",
    key: 'login',
    component: lazy(() => import("../pages/login")),
    isPrivate: false,
    exact: true,
  },
  {
    path: "/qrcode",
    key: 'qrcode',
    component: lazy(() => import("../pages/qrcode")),
    isPrivate: false,
    exact: true,
  }
];

export default routeConfig;
